import { faWifi } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useOnlineStatus } from "../hooks/use-online-status";

export function OnlineIndicator() {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed right-3 top-3 z-50 flex items-center gap-1.5 rounded-full bg-amber-500 px-3 py-1 text-xs font-semibold text-white shadow-lg">
      <FontAwesomeIcon className="h-3 w-3" icon={faWifi} />
      <span>Offline</span>
    </div>
  );
}
